import {ActionButtonProps} from "./ActionButton.tsx";
import {Bundle} from "../rpc/webrpc-client.gen.ts";
import {useCallback, useState} from "react";
import {Box, Button, DialogActions, DialogContent, DialogTitle, Modal, ModalDialog} from "@mui/joy";
import {useTranslation} from "react-i18next";
import {useNavigate} from "@tanstack/react-router";
import {useMutation} from "@tanstack/react-query";
import {useMothership} from "../tq/tqx.tsx";

export interface FieldCancelButtonProps extends Omit<ActionButtonProps, "children"> {
    bundle: Bundle;
}

const fieldCancelVerb = "FieldCancel";

export function FieldCancelButton({bundle, ...rest}: FieldCancelButtonProps) {
    const bundleId = bundle.id;
    const mama = useMothership();

    // const {data: scheduledTransferData}
    //     = useQuery(peekScheduledTransferForBundleTqo(mama, {bundleId: bundleId}));
    // const sxfer = scheduledTransferData?.scheduledTransfer;
    //
    // const {data: transferData}
    //     = useQuery(peekLastTransferForBundleTqo(mama, {bundleId}));
    // const xfer = transferData?.transfer;

    const performCancel = useCallback(() => {
        return mama.fieldCancelBundle({bundleId})
            // probably a bad idea to do this
            // .then(() => GLOBAL_MOTHERSHIP.retireBundle({bundleId}))
            .then(() => true);
    }, [bundleId, mama]);

    // const performInvalidate = useCallback(() => {
    //     const iset = new RefreshSetManager([
    //         {queryKey: bundleByIdTqk({bundleId})}
    //     ]);
    //     if (sxfer) {
    //         iset.add(scheduledBundleTransferRefreshSet(sxfer.id));
    //     }
    //     if (xfer) {
    //         iset.add([
    //             {queryKey: bundleTransferByIdTqk({transferId: xfer.id})},
    //             ...transferRefreshSet({transfer: xfer}).queryFilters,
    //         ]);
    //     }
    //     return iset.invalidate();
    // }, [bundleId, sxfer, xfer]);

    const {mutateAsync: performFieldCancel} = useMutation<boolean>({
        mutationKey: [fieldCancelVerb],
        mutationFn: performCancel,
//        onSuccess: performInvalidate,
    });
    const [isConfirmOpen, setIsConfirmOpen]
        = useState<boolean>(false);
    const navigate = useNavigate();
    const {t} = useTranslation();

    return <>
        <Button onClick={() => {
            setIsConfirmOpen(true);
        }} color="danger" variant="solid" {...rest}>
            {t("driver.fieldCancel")}
        </Button>

        <Modal open={isConfirmOpen}
               onClose={() => {
                   setIsConfirmOpen(false);
               }}
               sx={{display: "flex", justifyContent: "center", alignItems: "center"}}>
            <ModalDialog variant="outlined">
                <DialogTitle>
                    <Box sx={{fontSize: "lg"}}>{t("driver.fieldCancelDialogTitle")}</Box>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{fontSize: "lg"}}>{t("driver.fieldCancelDialogPrompt")}</Box>
                </DialogContent>
                <DialogActions>
                    <Button color="danger" variant="solid"
                            onClick={() => {
                                void performFieldCancel()
                                    .then(() => navigate({
                                        to: "/driver/schedule",
                                        params: {},
                                        search: {},
                                    }));
                            }}>
                        {t("driver.fieldCancelYes")}
                    </Button>
                    <Button color="neutral" variant="soft"
                            onClick={() => {
                                setIsConfirmOpen(false);
                            }}>
                        {t("driver.fieldCancelNo")}
                    </Button>
                </DialogActions>
            </ModalDialog>
        </Modal>
    </>
}
